import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable()
export class SendGridService {
  private _apiUrl = '/api/SendGrid';

  constructor(private _http: HttpService, private _httpClient: HttpClient) { }

  getAllSendGridEmail(clubId: number) {
    return this._http.get(
      this._apiUrl + `/get-all-sendgrid-emails-by-club-id/${clubId}`
    );
  }

  testSingleSend(clubId: number) {
    return this._http.get(
      this._apiUrl + `/test-single-send/${clubId}`
    );
  }


}



// WEBPACK FOOTER //
// ./src/app/services/sendgrid.service.ts